var map = {
	"./pla_1688.png": "4d32",
	"./pla_1HD.png": "e4f9",
	"./pla_ALST.png": "a5cf",
	"./pla_AMAZON.png": "13bc",
	"./pla_BBWG.png": "1a81",
	"./pla_CCJ.png": "0a12",
	"./pla_DD.png": "c261",
	"./pla_DY.png": "8c82",
	"./pla_GM.png": "1948",
	"./pla_HM.png": "9872",
	"./pla_JD.png": "89cd",
	"./pla_JINGXI.png": "b74d",
	"./pla_JMYP.png": "c218",
	"./pla_LZDMY.png": "3181",
	"./pla_LZDSG.png": "775e",
	"./pla_LZDVN.png": "1c67d",
	"./pla_MGJ.png": "1a5b",
	"./pla_MT.png": "9c9e",
	"./pla_PDD.png": "c62e",
	"./pla_SMT.png": "2e6d",
	"./pla_SN.png": "0c9b",
	"./pla_TB.png": "137b",
	"./pla_TM.png": "6aa6",
	"./pla_WECD.png": "996a",
	"./pla_WPH.png": "6d0b",
	"./pla_XHS.png": "469f",
	"./pla_XY.png": "e954",
	"./pla_YFW.png": "afee",
	"./pla_YJWD.png": "4abd",
	"./pla_YLW.png": "9069",
	"./pla_YYC.png": "5ad2",
	"./pla_ae.png": "e092",
	"./pla_gome.png": "6249",
	"./pla_platform_OTHER.png": "37ae",
	"./pla_sumaitong.png": "e656",
	"./pla_京东.png": "894a",
	"./pla_天猫.png": "115a",
	"./pla_淘宝.png": "43605",
	"./pla_淘宝网.png": "3417"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b0e3";